import Reflux from 'reflux';
import NotificationsActions from '../actions/NotificationsActions';
import axios from 'axios';

export default class ModalStore extends Reflux.Store {
    constructor () {
        super();
        this.state = {
            notifications: [],
            suggestedTops: [],
            apiUrl: process.env.REACT_APP_API_URL + '/api',
            loadingNotifications: false
        };
        this.listenables = NotificationsActions;
    }

    onGetNotifications (userId) {
        this.setState({loadingNotifications: true});
        return axios.get(this.state.apiUrl + '/notifications?limit=10&conditions{to: "' + userId + '"}&populate=from relatedTop&sort=-createdAt')
          .then((results) => {
              this.setState({notifications: results.data, loadingNotifications: false});
          })
          .catch((err) => {
              console.error(err);
              this.setState({loadingNotifications: false});
          });
    }

    onGetTopSuggestions () {
        return axios.get(this.state.apiUrl + '/usertopics?populate=createdBy&sort=-createdAt&limit=2')
          .then((results) => {
              this.setState({suggestedTops: results.data});
          });
    }

    onMarkAsReaded (notifId) {
        axios.put(this.state.apiUrl + '/notifications/' + notifId, {
            readed: true
        });
    }
}



// WEBPACK FOOTER //
// ./src/stores/NotificationsStore.js